<template>
    <v-flex class="liked_users" xs12>
        <v-card>
            <v-flex class="liked_users__inner__scroll">
                <v-flex class="liked_users__close">
                    <span class="liked_users__likes">{{likeCount}} 
                    <span v-if="likeCount > 1"> {{communityCommonConstant.liked_Users.Likes}}</span>
                    <span v-if="likeCount === 1"> {{communityCommonConstant.liked_Users.Like}}</span>
                    </span>
                    <v-btn flat icon class="closeIcon_unitTest" data-qe-id="close_dialog_btn" @click="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-divider></v-divider>
                </v-flex>

                <v-flex v-for='(likeUser,index) in likedUsers' :key="index">

                    <v-list two-line class="liked_users__list">
                        <v-list-tile>                             
                            <v-list-tile-avatar>
                                <img :src="likeUser.userProfileImageUrl"
                                    :onerror="imageErrorFallback(likeUser.fallbackProfileImageUrl)">
                        </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title bold>
                                        <strong  v-if="likedUsers.length === 1"
                                                 data-qe-id="single_liked_user_detail"
                                                 class="text-truncate">
                                          {{likeUser.firstName}} {{likeUser.lastName}}
                                        </strong>
                                        <strong v-if="likedUsers.length > 1"
                                                @click="openMemberProfile(likeUser.id)"
                                                :data-qe-id="`open_liked_member_profile_link_${index}`"
                                                class="text-truncate pointer">
                                            {{likeUser.firstName}} {{likeUser.lastName}}
                                        </strong>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title class="chapter_unitTest" :data-qe-id="`liked_user_${index}_chapter`">
                                        {{likeUser.chapter}}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                        </v-list-tile>
                        <v-btn v-if="showLiker" :data-qe-id="`view_liked_member_profile_link_${index}`"
                               @click="openMemberProfile(likeUser.id)" class="button">
                            {{communityCommonConstant.commented_Users.VIEW_PROFILE}}
                        </v-btn>

                    </v-list>

                </v-flex>
            </v-flex>

        </v-card>
    </v-flex>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import { communityCommonConstant } from "../communityCommon.constant";
  import { storeAction } from "../../../store/storeActions.constant";
  import { storeGetters } from "../../../store/storeGetters.constant";
  import { imageErrorFallback } from "../../../common/utils/utils";

  export default {
    name: "LikedUsers",
    data() {
      return {
        showLiker: false,
        communityCommonConstant,
      };
    },
    props: {
      postId: {
        type: String,
        required: true,
      },
      userHasLiked: {
        type: Boolean,
        required: true,
      },
      likeCount: {
        type: Number,
        required: true,
      },
      likeDialogState: {
        type: Object,
        default: () => ({}),
      },
    },
    created() {
      this.clearLikedUsersList();
      this.getLikedUsersList(this.postId);
      this.DisplayViewProfile();
    },
    methods: {
      ...mapActions({
        getLikedUsersList: `chapter/${storeAction.getLikedUsers}`,
        getChapterAdmin: `memberProfile/${storeAction.getChapterAdmin}`,
        handleLaunchOfMemberProfile: `memberProfile/${storeAction.handleLaunchOfMemberProfile}`,

      }),
      imageErrorFallback,
      DisplayViewProfile() {
        if (!this.userHasLiked && this.likeCount === 1) {
          this.showLiker = true;
          return true;
        }
        return false;
      },
      closeDialog() {
        this.likeDialogState.likeDialogOpen = false;
      },
      clearLikedUsersList() {
        this.likedUsers = null;
      },
      openMemberProfile(id) {
          this.handleLaunchOfMemberProfile({
              memberId: id,
              name: this.communityInfo && !this.$route.name.includes('home') ? this.communityInfo.name : this.communityCommonConstant.YPO_HOME,
              router: this.$router,
          });
      },
    },
    computed: {
        ...mapGetters({
            likedUsers: `chapter/${storeGetters.likedUsers}`,
            communityInfo: `chapter/${storeGetters.communityInfo}`,
            chapterAdmin: `memberProfile/${storeGetters.chapterAdmin}`,
            currentUserId: `memberProfile/${storeGetters.currentUserId}`,
        }),
    },
  };
</script>

<style lang="scss">
  @import "../../../common/styles/_colors.scss";
  @import "../../../common/styles/_responsive.scss";

  .liked_users {
    &__list {
      margin: 0 15px;
      padding: 0;

      .v-list__tile {
        padding: 0 0 20px 0;
        height: auto;
        border-bottom: 1px solid $ypo-title-border;
        margin: 0 0 15px 0;

        &__title {
          font-size: 14px;
          color: $ypo-gray-text;
          font-weight: 700;

          strong {
            width: 70%;
            display: inline-block;
            vertical-align: middle;
            padding-right: 10px;
          }

          span {
            color: rgba($ypo-gray-text, 0.7);
            font-weight: 400;
            font-size: 14px;
          }
        }

        &__sub-title {
          font-size: 12px;
          margin-top: 5px;
          color: rgba($ypo-gray-text, 0.7);
        }
      }
    }

    &__viewProfile {
      color: $white !important;
      background-color: $ypo-blue !important;
      left: 150px;
    }

    &__inner__scroll {
      overflow: auto;
      max-height: 80vh;
      position: relative;
      padding: 15px 0;
    }

    &__close {
      position: relative;
      margin-bottom: 15px;

      .v-btn {
        position: absolute;
        right: -5px;
        z-index: 1;
        top: -20px;
      }
    }

    &__likes {
      color: $ypo-text-border;
      font-size: 16px;
      padding: 0 0 10px 15px;
      display: inline-block;
    }

    .v-card {
      border-radius: 4px;
      box-shadow: none;
    }
  }

  .button {
    margin-left: 180px !important;
    background-color: $ypo-blue !important;
    color: $white !important;
  }
</style>
